import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Container from '../Container';
import { LockOutlined } from '@ant-design/icons';

interface NavItem {
  key: string;
  label: string;
  link: string;
  isExternal?: boolean;
}
const Footer: React.FC = () => {
  const { t } = useTranslation('footer');
  const { t: tCommon } = useTranslation('translation');
  const navItems: NavItem[] = [
    { key: 'staking', label: tCommon('nav-staking'), link: 'https://www.48.club/staking' },
    { key: 'nft', label: tCommon('nav-nft'), link: 'https://www.48.club/nft' },
    { key: 'soul', label: tCommon('nav-soul'), link: 'https://soul.48.club/soul' },
    { key: 'voting', label: tCommon('nav-voting'), link: 'https://www.48.club/voting' },
    { key: 'farm', label: tCommon('nav-farm'), link: 'https://www.48.club/pool' },
    { key: 'trade', label: tCommon('nav-trade'), link: 'https://www.48.club/trade-race' },
  ];
  const navItems2: NavItem[] = [
    { key: 'committee', label: tCommon('app_header_menu_committee_title'), link: 'https://www.48.club/committee' },
    { key: 'node', label: tCommon('app_header_menu_node_title'), link: 'https://www.48.club/delegate' },
    { key: 'milestone', label: tCommon('app_header_menu_milestone_title'), link: 'https://www.48.club/milestome' },
    { key: 'docs', label: tCommon('app_header_menu_docs_title'), link: 'https://docs.48.club', isExternal: true },
  ];
  const navItems3: NavItem[] = [
    { key: 'committee', label: 'https://rpc.48.club/', link: 'https://rpc.48.club/', isExternal: true },
    { key: 'node', label: 'https://0.48.club (Soul>=48)', link: 'https://0.48.club', isExternal: true },
  ];
  const renderNavItem = (item: NavItem) => {
    if (item.isExternal) {
      return (
        <a 
          key={item.key}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-14 text-gray-500 "
        >
          {item.label}
        </a>
      );
    }
    
    return (
      <Link 
        key={item.key}
        to={item.link}
        className="text-14 text-gray-500"
      >
        {item.label}
      </Link>
    );
  };
  return (
      <footer className="relative bg-gray-950 text-white pt-[194px] pb-[88px] mt-auto">
        <div className="absolute top-0 left-0 w-full h-full opacity-50 z-1" style={{ backgroundImage: 'url(/soul/soul-bg.png)', backgroundSize: 'cover', backgroundPosition: 'top' }}></div>
        <div className="absolute top-0 left-0 w-full h-full opacity-50 z-1">
          <img src="/footer/text.png" alt="footer-bg" className="w-[70%] mx-auto pt-[100px]" />
        </div>
        <Container className="container mx-auto px-[48px] py-[40px] bg-gray-900 relative z-10">
          <div className="flex justify-between flex-col sm:flex-row">
            {/* Logo and Description */}
            <div className="w-[300px]">
              <div className="flex items-center mb-4">
                <img 
                  src="/logo-yellow.svg" 
                  alt="48CLUB" 
                  className="h-8 mr-3"
                />
              </div>
              <div className="flex align-center my-[32px]">
                <a href="https://twitter.com/48club_official" target="_blank" rel="noopener noreferrer">
                  <img src="/footer/icon-social-twitter.svg" alt="x" className="w-[24px] h-[24px] mr-[16px]" />
                </a>
                <a href="https://t.me/en_48club" target="_blank" rel="noopener noreferrer">
                  <img src="/footer/icon-social-telegram.png" alt="discord" className="w-[24px] h-[24px] mr-[16px]" />
                </a>
                <a href="https://github.com/48Club" target="_blank" rel="noopener noreferrer">
                  <img src="/footer/icon-social-github.png" alt="github" className="w-[24px] h-[24px] mr-[16px]" />
                </a>
                <a href="https://discord.gg/DDeeWYdCyJ" target="_blank" rel="noopener noreferrer">
                  <img src="/footer/icon-social-discord.png" alt="github" className="w-[24px] h-[24px] mr-[16px]" />
                </a>
                <a href="https://medium.com/48-club-publish" target="_blank" rel="noopener noreferrer">
                  <img src="/footer/icon-social-medium.png" alt="github" className="w-[24px] h-[24px]" />
                </a>
              </div>
            </div>

            <div className="flex flex-1 justify-between flex-col sm:flex-row">
              <div className="flex">
                {/* Quick Links */}
                <div className="mr-[100px]">
                  <h3 className="text-lg font-semibold mb-4">{t('footer_function')}</h3>
                  <nav className="flex flex-col gap-2">
                    {navItems.map(renderNavItem)}
                  </nav>
                </div>

                {/* Support */}
                <div>
                  <h3 className="text-lg font-semibold mb-4">{t('footer_about')}</h3>
                  <nav className="flex flex-col gap-2">
                    {navItems2.map(renderNavItem)}
                  </nav>
                </div>
              </div>
              <div className='mt-[30px] sm:mt-0'>
                <h3 className="text-lg font-semibold mb-4">{t('footer_mev_protected_rpc')}</h3>
                <nav className="flex flex-col gap-2">
                  {navItems3.map(renderNavItem)}
                </nav>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 mt-8 pt-6">
            <p className="text-gray-600 text-sm">
              {t('footer_all_rights_reserved')}
            </p>
            <div className="flex mt-[16px] justify-between">
              <div  className="text-gray-600 text-sm">
                {t('footer_terms_of_service')}
              </div>
              <div className="text-gray-600 text-sm">
                <LockOutlined />{t('footer_privacy_policy')}
              </div>
            </div>
          </div>
        </Container>
      </footer>
  );
};

export default Footer; 